import React, {Component} from "react";
import Form from "./GiftMessageForm";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {cancelAddGiftMessage, successAddGiftMessage} from "../../actions/CheckoutApiActions";
import {Map} from "immutable";

class AddGiftMessageFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("orderId", this.props.orderId)
                              .set("template", "default");
    if (values.get("message", "") === "") return;

    return this.props.markAsGift(updatedValues.toJS())
      .then((response) => {
        if (response.data.markAsGift.errors.length <= 0) {
          this.setState({errors: []});     
          this.props.successAddGiftMessage();   
        } else {
          let errors = createValidationErrors(response.data.markAsGift.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAddGiftMessage();
  }

  render() {
    let initialValues = Map({
      message: ""
    });
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const MARK_AS_GIFT = gql`
  mutation markAsGift($data: MarkAsGiftInput!) {
    markAsGift(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(MARK_AS_GIFT, {
    props: ({ mutate }) => ({
      markAsGift: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);


export default connect(null, {cancelAddGiftMessage, successAddGiftMessage})(withQueries(AddGiftMessageFormContainer));